/**
 * Back-compat shim: all Discord activity flows through trackActivityEvent.
 *
 * Mixpanel remains helpers/mixpanel `trackEvent` - do not confuse the two.
 */

import { trackActivityEvent } from "./trackActivityEvent";

/**
 * @param {string} event
 * @param {Record<string, unknown>} [metadata]
 */
export async function discordTrack(event, metadata = {}) {
  trackActivityEvent(event, metadata && typeof metadata === "object" ? metadata : {});
}
